import ApiService from "./apiservice";

export const SettingsService = {
    readwebkartsetting() {
        return ApiService.get("setting/readwebkartsetting");
    },
    readSystemTable() {
        return ApiService.get("setting/readSystemTable");
    },
    getClockSelection() {
        return ApiService.get("setting/getClockSelection");
    },
    VacationUseWorkCalendar() {
        return ApiService.get("setting/VacationUseWorkCalendar");
    },
    TruncateApprovedVacation() {
        return ApiService.post("setting/TruncateApprovedVacation");
    },
    TruncateApprovedMission() {
        return ApiService.post("setting/TruncateApprovedMission");
    },
    IsActvieSecurity() {
        return ApiService.get("setting/IsActvieSecurity");
    },
    GetAlarmExpire(params) {
        return ApiService.get("setting/GetAlarmExpire",params);
    },
    GetAllStateForAdmin(payload) {
        return ApiService.get("mainmenu/GetAllStateForAdmin", payload);
    },
    SetActiveDirectory(params) {
        return ApiService.post("setting/SetActiveDirectory", null, params);
    },
    AddApproveMission(params) {
        return ApiService.post("setting/AddApproveMission", null, params);
    },
    AddApproveVacation(params) {
        return ApiService.post("setting/AddApproveVacation", null, params);
    },
    SetWebVacations(data) {
        return ApiService.post("setting/SetWebVacations",  data);
    },
    SetWebMissions(data) {
        return ApiService.post("setting/SetWebMissions",  data);
    },
    WriteSystemTable(params) {
        return ApiService.post("setting/WriteSystemTable", null, params);
    },
    AddDefaultCity(params) {
        return ApiService.post("setting/AddDefaultCity", null, params);
    },
    UpdateEventFlag(params) {
        return ApiService.post("setting/UpdateEventFlag", null, params);
    },
    UpdateBirthDayFlag(params) {
        return ApiService.post("setting/UpdateBirthDayFlag", null, params);
    },
    UpdateAllowIoInCurrentDay(params) {
        return ApiService.post("setting/UpdateAllowIoInCurrentDay", null, params);
    },
    UpdateClock(params) {
        return ApiService.post("setting/UpdateClock", null, params);
    },
    updateVacationCalendar(params) {
        return ApiService.post("setting/updateVacationCalendar", null, params);
    },
    UpdateLimitationDays(data) {
        debugger
        return ApiService.post("setting/UpdateLimitationDays", data);
    },
    UpdateSomeAddedField(data) {
        return ApiService.post("setting/UpdateSomeAddedField", data);
    },
    UpdateportalAccess(data) {
        return ApiService.post("setting/UpdateportalAccess", data);
    },
    CheckConfiremReqestDeadLine() {
        return ApiService.get("setting/CheckConfiremReqestDeadLine");
    },
    GetAlertBirthDay() {
        return ApiService.get("GetAlertBirthDay");
    },
};